import Config from '../ClientConfig';

const EMPTY_QUERY = {};

function getData(client, url, queryData = EMPTY_QUERY) {
  if (!client || typeof client.getData !== 'function') {
    return null;
  }
  return client.getData(url, queryData);
}

function getDataAsync(client, url, queryData = EMPTY_QUERY) {
  if (!client || typeof client.getDataAsync !== 'function') {
    return Promise.reject(new Error('Asynchronous report transport is unavailable.'));
  }
  return client.getDataAsync(url, queryData);
}

function pushData(client, url, queryData = EMPTY_QUERY) {
  if (!client || typeof client.pushData !== 'function') {
    return null;
  }
  return client.pushData(url, queryData);
}

const BackofficeReportsApi = {
  getLocations(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_LOCATIONS_LIST, queryData);
  },

  getLocationGroups(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_LOCATIONS_GROUPS, queryData);
  },

  getProductsCatalogSummary(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_CATALOG_SUMMARY, queryData);
  },

  getProductsByCategory(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_BY_CATEGORY, queryData);
  },

  getProductsLatestImages(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_LATEST_IMAGES, queryData);
  },

  getProductsSoldMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_SOLD_MTD, queryData);
  },

  getProductsTopShareMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_TOP_SHARE_MTD, queryData);
  },

  getProductsTopListMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_TOP_LIST_MTD, queryData);
  },

  getProductsSalesMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_SALES_MTD, queryData);
  },

  getProductsClassShareMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_CLASS_SHARE_MTD, queryData);
  },

  getProductsCategoryShareMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_CATEGORY_SHARE_MTD, queryData);
  },

  getProductsSubcategoryShareMtd(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PRODUCTS_SUBCATEGORY_SHARE_MTD, queryData);
  },

  getPosStatus(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_LOCATIONS_POS_STATUS, queryData);
  },

  getSalesLocationTimeseries(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_LOCATION_TIMESERIES, queryData);
  },

  getSalesSummary(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_SUMMARY, queryData);
  },

  getSalesTop(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_TOP, queryData);
  },

  getSalesByPos(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_POS, queryData);
  },

  getSalesDailyKpi(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_DAILY_KPI, queryData);
  },

  postSalesLocationTrends(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_SALES_LOCATION_TRENDS, queryData);
  },

  postSalesProductTrends(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_SALES_PRODUCT_TRENDS, queryData);
  },

  getSalesByLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_LOCATION, queryData);
  },

  getSalesByDeliveryChannel(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_DELIVERY_CHANNEL, queryData);
  },

  getSalesByProduct(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_PRODUCT, queryData);
  },

  getSalesProductLocationTimeseries(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_PRODUCT_LOCATION_TIMESERIES, queryData);
  },

  getSalesByProductLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_PRODUCT_LOCATION, queryData);
  },

  getSalesByCategory(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_CATEGORY, queryData);
  },

  getSalesByCategoryLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_CATEGORY_LOCATION, queryData);
  },

  getSalesCategoryLocationTimeseries(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_CATEGORY_LOCATION_TIMESERIES, queryData);
  },

  getSalesClassLocationTimeseries(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_CLASS_LOCATION_TIMESERIES, queryData);
  },

  getSalesProductDaily(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_PRODUCT_DAILY, queryData);
  },

  getSalesCategoryDaily(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_CATEGORY_DAILY, queryData);
  },

  getSalesLocationValueComparison(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_LOCATION_VALUE_COMPARISON, queryData);
  },

  getSalesLocationTransactionComparison(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_LOCATION_TRANSACTION_COMPARISON, queryData);
  },

  getSalesForecast(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_FORECAST, queryData);
  },

  getSalesCategoryTargets(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_CATEGORY_TARGETS, queryData);
  },

  getSalesByPaymentType(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_SALES_BY_PAYMENT_TYPE, queryData);
  },

  getOrdersRecent(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_RECENT, queryData);
  },

  getOrdersByLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_BY_LOCATION, queryData);
  },

  getOrdersList(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_LIST, queryData);
  },

  getOrdersCount(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_COUNT, queryData);
  },

  getOrdersByLocationUrl() {
    return Config.API_URL_REPORTS_V2_ORDERS_BY_LOCATION;
  },

  getOrdersInvoices(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_INVOICES, queryData);
  },

  getOrdersDetail(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_ORDERS_DETAIL, queryData);
  },

  getClientsList(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_LIST, queryData);
  },

  getClientsListAsync(client, queryData = EMPTY_QUERY) {
    return getDataAsync(client, Config.API_URL_REPORTS_V2_CLIENTS_LIST, queryData);
  },

  getClientsEvolutionAsync(client, queryData = EMPTY_QUERY) {
    return getDataAsync(client, Config.API_URL_REPORTS_V2_CLIENTS_EVOLUTION, queryData);
  },

  getClientsDistributionsAsync(client, queryData = EMPTY_QUERY) {
    return getDataAsync(client, Config.API_URL_REPORTS_V2_CLIENTS_DISTRIBUTIONS, queryData);
  },

  getClientsActivationAsync(client, queryData = EMPTY_QUERY) {
    return getDataAsync(client, Config.API_URL_REPORTS_V2_CLIENTS_ACTIVATION, queryData);
  },

  getClientsSummary(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_SUMMARY, queryData);
  },

  getClientsNew(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_NEW, queryData);
  },

  getClientsActive(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_ACTIVE, queryData);
  },

  getClientsRepeat(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_REPEAT, queryData);
  },

  getClientsRegisteredAnonymousSummary(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_REGISTERED_ANONYMOUS_SUMMARY, queryData);
  },

  getClientsRegisteredAnonymousEvolution(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_REGISTERED_ANONYMOUS_EVOLUTION, queryData);
  },

  getClientsRegisteredAnonymousComparison(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_REGISTERED_ANONYMOUS_COMPARISON, queryData);
  },

  getClientsRegisteredActivityByLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_CLIENTS_REGISTERED_ACTIVITY_BY_LOCATION, queryData);
  },

  getDemographicsGender(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_DEMOGRAPHICS_GENDER, queryData);
  },

  getDemographicsAge(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_DEMOGRAPHICS_AGE, queryData);
  },

  getGeographyCounty(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_GEOGRAPHY_COUNTY, queryData);
  },

  getGeographyUrbanRural(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_GEOGRAPHY_URBAN_RURAL, queryData);
  },

  getPromotionsKpiSummary(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PROMOTIONS_KPI_SUMMARY, queryData);
  },

  getPromotionsActivityEvolution(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PROMOTIONS_ACTIVITY_EVOLUTION, queryData);
  },

  getPromotionsPerformance(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PROMOTIONS_PERFORMANCE, queryData);
  },

  getPromotionsOpenClaims(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PROMOTIONS_OPEN_CLAIMS, queryData);
  },

  getPromotionsOrdersByLocation(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_PROMOTIONS_ORDERS_BY_LOCATION, queryData);
  },

  getMarginsByProduct(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_MARGINS_BY_PRODUCT, queryData);
  },

  getMarginsByProductLocations(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_MARGINS_BY_PRODUCT_LOCATIONS, queryData);
  },

  getMarginsByProductUrl() {
    return Config.API_URL_REPORTS_V2_MARGINS_BY_PRODUCT;
  },

  getMarginsByProductLocationsUrl() {
    return Config.API_URL_REPORTS_V2_MARGINS_BY_PRODUCT_LOCATIONS;
  },

  getMarginsPvm(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_MARGINS_PVM, queryData);
  },

  getMarginsPvmSales(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_MARGINS_PVM_SALES, queryData);
  },

  getMarginsPvmUrl() {
    return Config.API_URL_REPORTS_V2_MARGINS_PVM;
  },

  getMarginsPvmSalesUrl() {
    return Config.API_URL_REPORTS_V2_MARGINS_PVM_SALES;
  },

  getExportsList(client, queryData = EMPTY_QUERY) {
    return getData(client, Config.API_URL_REPORTS_V2_EXPORTS, queryData);
  },

  getExportsDownloadUrl(fileName) {
    if (!fileName) return '';
    return `${Config.API_URL_REPORTS_V2_EXPORTS_DOWNLOAD}?file=${encodeURIComponent(fileName)}`;
  },

  postExportSalesProductsByDate(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_SALES_PRODUCTS_BY_DATE, queryData);
  },

  postExportSalesLocationsByDate(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_SALES_LOCATIONS_BY_DATE, queryData);
  },

  postExportSalesProductsByMonth(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_SALES_PRODUCTS_BY_MONTH, queryData);
  },

  postExportSalesLocationsByMonth(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_SALES_LOCATIONS_BY_MONTH, queryData);
  },

  postExportSalesProductsDelivery(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_SALES_PRODUCTS_DELIVERY, queryData);
  },

  postExportCompanySalesDetail(client, queryData = EMPTY_QUERY) {
    return pushData(client, Config.API_URL_REPORTS_V2_EXPORTS_COMPANY_SALES_DETAIL, queryData);
  },

  get(client, url, queryData = EMPTY_QUERY) {
    return getData(client, url, queryData);
  },

  post(client, url, queryData = EMPTY_QUERY) {
    return pushData(client, url, queryData);
  },
};

export default BackofficeReportsApi;
